import { useContent } from '../ContentContext';
import { PageHero, SectionHead } from '../components/Common';

export default function VisionMission() {
  const { visionMission = {}, storyCards = [] } = useContent();
  const { vision, mission, values = [] } = visionMission;

  // The banner keeps using the mission artwork when one is set in admin.
  const bannerImg = storyCards.find((c) => c.title === 'Vision And Mission')?.image;

  return (
    <>
      <PageHero title="Vision & Mission" image={bannerImg} />

      {vision ? (
        <section className="vision-section">
          <div className="container">
            <div className="vision-card">
              <div className="vision-icon">
                <i className={`fas ${vision.icon || 'fa-eye'}`} />
              </div>
              <h2>{vision.title}</h2>
              <p>{vision.text}</p>
            </div>
          </div>
        </section>
      ) : null}

      {mission ? (
        <section className="mission-section">
          <div className="container">
            <div className="mission-card">
              <div className="mission-icon">
                <i className={`fas ${mission.icon || 'fa-bullseye'}`} />
              </div>
              <h2>{mission.title}</h2>
              <p>{mission.text}</p>
            </div>
          </div>
        </section>
      ) : null}

      {values.length ? (
        <section className="values-section">
          <div className="container">
            <SectionHead title="Our Core Values" />
            <div className="values-grid">
              {values.map((v) => (
                <div className="value-card" key={v.title}>
                  <i className={`fas ${v.icon}`} />
                  <h3>{v.title}</h3>
                  <p>{v.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}
